export default __webpack_public_path__ + "static/media/ux.d85a8932.svg";